export default "__VITE_ASSET__DF3tWzt5__"